import React from 'react';
import './normalPages.scss'

const TermsAndCondition = () => {
    return (
        <>
            <div className="normal_page">
                <h1>TERMS AND CONDITIONS OF USE</h1>

                <div className="content">
                    <h2>Rule 1</h2>

                    <p>Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </p><br /> <br />

                    <h2>Rule 2</h2>

                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam odit iure deserunt voluptates. Nihil sapiente, velit dolore aliquid dolorem placeat accusamus culpa quidem ipsam veniam inventore fugiat ullam voluptate sed ut recusandae voluptatem quis. Amet ab deserunt eius quia maiores? Fugiat corrupti dolorum commodi voluptatum natus temporibus magni repudiandae suscipit.
                        <br />

                        <br />
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam odit iure deserunt voluptates. Nihil sapiente, velit dolore aliquid dolorem placeat accusamus culpa quidem ipsam veniam inventore fugiat ullam voluptate sed ut recusandae voluptatem quis. Amet ab deserunt eius quia maiores? Fugiat corrupti dolorum commodi voluptatum natus temporibus magni repudiandae suscipit. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum, voluptatum aspernatur ad reprehenderit voluptas cupiditate obcaecati quas tenetur eaque dolor?

                    </p>
                    <br /> <br />

                    <h2>Rule 3</h2>

                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam odit iure deserunt voluptates. Nihil sapiente, velit dolore aliquid dolorem placeat accusamus culpa quidem ipsam veniam inventore fugiat ullam voluptate sed ut recusandae voluptatem quis. Amet ab deserunt eius quia maiores? Fugiat corrupti dolorum commodi voluptatum natus temporibus magni repudiandae suscipit. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum, voluptatum aspernatur ad reprehenderit voluptas cupiditate obcaecati quas tenetur eaque dolor?

                        <br />
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam odit iure deserunt voluptates. Nihil sapiente, velit dolore aliquid dolorem placeat accusamus culpa quidem ipsam veniam inventore fugiat ullam voluptate sed ut recusandae voluptatem quis. Amet ab deserunt eius quia maiores? Fugiat corrupti dolorum commodi voluptatum natus temporibus magni repudiandae suscipit. Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nostrum, voluptatum aspernatur ad reprehenderit voluptas cupiditate obcaecati quas tenetur eaque dolor?

                    </p>
                    <br /> <br />
                </div>


            </div>
        </>
    );
};

export default TermsAndCondition;